import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MEDIAN = () => {
  return (
    <CardSection id="MEDIAN" title="MEDIAN">
      <Paragraph>
        가장 낮은 값부터 가장 높은 값 순으로 정렬된 숫자 범위의 중간에 있는
        숫자를 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MEDIAN(VALUE_1, [VALUE_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeMax" /> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          숫자가 짝수인 범위에서 중간값은 중앙 숫자이고, 숫자의 절반은 반환된
          값의 오른쪽에 있고, 숫자의 절반은 반환된 값의 왼쪽에 있습니다. 범위
          중간에 숫자가 하나도 없는 경우, MEDIAN은 중간 지점의 양쪽에 있는 두
          숫자의 평균을 계산합니다.
        </Paragraph>
        <Paragraph>
          <b>MEDIAN</b>은 <b>AVERAGE</b>와 다릅니다. <b>AVERAGE</b>는 산술
          평균입니다. 숫자 집합을 더한 다음 집합의 값 개수로 나누어 계산합니다.{" "}
          <b>MEDIAN</b>은 단순히 범위의 중앙에 있는 값을 취합니다. 컬렉션 내 값
          분포에서 균형을 보이는 숫자 범위에서 <b>MEDIAN</b> 및 <b>AVERAGE</b>{" "}
          계산이 일치할 수 있습니다. 비대칭 분포에서는 값이 다릅니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
